<div class="row mb-3">
  <div [ngClass]="{'col-lg': true, 'col-lg-12': !data.EqHubTekNo, 'col-lg-10': data.EqHubTekNo}">
    <table class="table table-heading-5 padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="max-w-140">{{ data?.MainObject }}</td>
        <td>{{ data?.ServiceDescription }}</td>
      </tr>
      <tr>
        <td class="max-w-140 fs-12">Doc.ref:</td>
        <td class="fs-12">{{ data?.DocumentReference }}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <ng-container *ngIf="data.EqHubTekNo">
    <div class="col-lg col-lg-2">
      <span class="float-lg-end me-2">
        <a [href]="data.EqHubTekNo" class="mt-0 float-lg-end doc-db-icon" target="_blank">
          <img src="./assets/images/icons/doc-db_icon.svg" alt="">
        </a>
      </span>
    </div>
  </ng-container>

</div>

<!-- RCA-O Badge -->
<app-rca-tag
  [tagName]="data?.MainObject"
  [active]="data?.Ovr_Active"
  [inactive]="data?.Ovr_InActive"
  [inactiveCount]="data?.Ovr_InActive_Count"
  [type]="'RCA-O'"></app-rca-tag>
<!-- RCA-O Badge -->

<!-- TABS -->
<div class="form-group">
  <div class="row">
    <div class="col-lg-12">
      <div class="mt-3">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">

          <!-- CAUSE -->
          <li [ngbNavItem]="1">
            <a ngbNavLink>Causes</a>
            <ng-template ngbNavContent>
              <div class="p-4 border border-top-0">
                <!-- XS -->
                <p class="fs-12 mb-1">
                  <strong>XS</strong>
                </p>
                <ng-container *ngIf="data.xs.length; else noData">
                  <table class="table table-bordered">
                    <thead>
                    <tr>
                      <th class="fs-12">Causes</th>
                      <th class="fs-12">Delay (s)</th>
                      <th class="fs-12">Conditional</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let xs of data.xs">
                      <td class="fs-12">{{ xs.MainObject }}</td>
                      <td class="fs-12 text-center">{{ xs.DelaySeconds }}</td>
                      <td class="fs-12 text-center">
                        <ng-container *ngIf="xs.Conditional">
                          <span
                            class="badge badge-light px-2 pe-2 cursor-pointer border border-dark"
                            ngbTooltip="{{ xs.Conditional }}">Cond.</span>
                        </ng-container>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </ng-container>

                <!-- X -->
                <p class="fs-12 mb-1">
                  <strong>X</strong>
                </p>
                <ng-container *ngIf="data.x.length; else noData">
                  <table class="table table-bordered mb-0">
                    <thead>
                    <tr>
                      <th class="fs-12">Causes</th>
                      <th class="fs-12">Delay (s)</th>
                      <th class="fs-12">Conditional</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let x of data.x">
                      <td class="fs-12">{{ x.MainObject }}</td>
                      <td class="fs-12 text-center">{{ x.DelaySeconds }}</td>
                      <td class="fs-12 text-center">
                        <ng-container *ngIf="x.Conditional">
                          <span
                            class="badge badge-light px-2 pe-2 cursor-pointer border border-dark"
                            ngbTooltip="{{ x.Conditional }}">Cond.</span>
                        </ng-container>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </ng-container>
              </div>
            </ng-template>
          </li>

          <!-- EFFECTS -->
          <li [ngbNavItem]="2">
            <a ngbNavLink>Effects</a>
            <ng-template ngbNavContent>
              <div class="p-4 border border-top-0">
                <!-- YS -->
                <p class="fs-12 mb-1">
                  <strong>YX</strong>
                </p>
                <ng-container *ngIf="data.yx.length; else noData">
                  <table class="table table-bordered">
                    <thead>
                    <tr>
                      <th class="fs-12">Effects</th>
                      <th class="fs-12">Delay (s)</th>
                      <th class="fs-12">Conditional</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let yx of data.yx">
                      <td class="fs-12">{{ yx.MainObject }}</td>
                      <td class="fs-12 text-center">{{ yx.DelaySeconds }}</td>
                      <td class="fs-12 text-center">
                        <ng-container *ngIf="yx.Conditional">
                          <span
                            class="badge badge-light px-2 pe-2 cursor-pointer border border-dark"
                            ngbTooltip="{{ yx.Conditional }}">Cond.</span>
                        </ng-container>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </ng-container>

                <!-- Y -->
                <p class="fs-12 mb-1">
                  <strong>Y</strong>
                </p>
                <ng-container *ngIf="data.y.length; else noData">
                  <table class="table table-bordered mb-0">
                    <thead>
                    <tr>
                      <th class="fs-12">Effects</th>
                      <th class="fs-12">Delay (s)</th>
                      <th class="fs-12">Conditional</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let y of data.y">
                      <td class="fs-12">{{ y.MainObject }}</td>
                      <td class="fs-12 text-center">{{ y.DelaySeconds }}</td>
                      <td class="fs-12 text-center">
                        <ng-container *ngIf="y.Conditional">
                          <span
                            class="badge badge-light px-2 pe-2 cursor-pointer border border-dark"
                            ngbTooltip="{{ y.Conditional }}">Cond.</span>
                        </ng-container>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </ng-container>
              </div>
            </ng-template>
          </li>

        </ul>
        <div [ngbNavOutlet]="nav" class="mt-0"></div>
      </div>
    </div>
  </div>
</div>
<ng-template #noData>
  <div class="nz-spin-h">
    <nz-alert nzType="info" nzMessage="No data available!" nzCloseable></nz-alert>
  </div>
</ng-template>
